import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import PhoneIcon from "@material-ui/icons/Phone";
import * as Dati from "../../../Dati";
import * as Glob from "../../../Globale";
import { Trad } from "../../../components";
import { _Autocomplete, _DateField, _Select } from "../../form";
import { ContactTypeIcons } from "../../config/Icons";

interface IContactDetailsProps {
    Data: Glob.DatiJSON;
    OnChange: (val: string) => void;
}

const useStyles = makeStyles(({ shape, spacing, palette }: Theme) => ({
    icon: {
        marginRight: spacing(2)
    },
    title: {
        flexGrow: 1
    },
    toolbar: {
        background: palette.success.light,
        borderRadius: shape.borderRadius,
        color: palette.success.contrastText,
        marginTop: spacing(4),
        marginBottom: spacing(2)
    },
    removeBtn: {
        color: palette.error.main,
        background: "none"
    },
    divider: {
        marginTop: spacing(3),
        marginBottom: spacing(3)
    }
}));

export const _ContactDetails: React.FC<IContactDetailsProps> = ({ Data, OnChange }) => {
    const classes = useStyles();
    const details: Dati.CDatoRubrica[] = Data ? JSON.parse(Data) : [];

    const contactTypes: Dati.TDictTipo = {};
    contactTypes["1"] = new Dati.CTipo("1", "Telefono");
    contactTypes["2"] = new Dati.CTipo("2", "Cellulare");
    contactTypes["3"] = new Dati.CTipo("3", "Fax");
    contactTypes["4"] = new Dati.CTipo("4", "Email");
    contactTypes["5"] = new Dati.CTipo("5", "PEC");

    const OnDetailChange = (name: string, val: string, index: number) => {
        details[index][name] = val;
        OnChange(JSON.stringify(details));
    };

    const OnRemoveDetail = (index: number) => {
        details.splice(index, 1);
        OnChange(JSON.stringify(details));
    };

    const OnAddDetail = () => {
        details.push(new Dati.CDatoRubrica());
        OnChange(JSON.stringify(details));
    };

    return (
        <>
            <Toolbar variant="dense" className={classes.toolbar}>
                <PhoneIcon className={classes.icon} />
                <Typography variant="subtitle1" color="inherit" className={classes.title}>
                    {Trad.Trad("Recapiti")}
                </Typography>
                <Tooltip title={Trad.Trad("Nuovo recapito")}>
                    <IconButton size="small" aria-label="add contact details" onClick={OnAddDetail}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>
            </Toolbar>
            {details.map((detail: Dati.CDatoRubrica, index: number) => (
                <div key={index}>
                    <Grid container spacing={4} justify="space-between" alignItems="center" key={index}>
                        <Grid item container xs={12} md={11} spacing={4}>
                            <Grid item xs={12} md={2}>
                                <_Select
                                    Value={detail.ID_Tipologia || ""}
                                    Name="ID_Tipologia"
                                    Label="Tipo"
                                    OnChange={(name, val: string) => {
                                        OnDetailChange(name, val, index);
                                    }}
                                    Options={contactTypes}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    value={detail.Valore}
                                    id="Valore"
                                    label={Trad.Trad("Recapito")}
                                    onChange={e => OnDetailChange(e.currentTarget.id, e.currentTarget.value, index)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Icon fontSize="small" color="action">
                                                    {ContactTypeIcons[detail.ID_Tipologia] || ContactTypeIcons[0]}
                                                </Icon>
                                            </InputAdornment>
                                        )
                                    }}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        row
                                        aria-label="gender"
                                        name="TipoRecapito"
                                        value={detail.TipoRecapito || ""}
                                        onChange={e => OnDetailChange(e.currentTarget.name, e.currentTarget.value, index)}
                                    >
                                        <FormControlLabel value="PE" control={<Radio />} label={Trad.Trad("Personale")} />
                                        <FormControlLabel value="PR" control={<Radio />} label={Trad.Trad("Professionale")} />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Tooltip title={Trad.Trad("Elimina")}>
                                <IconButton
                                    disableRipple
                                    className={classes.removeBtn}
                                    aria-label="remove contact details"
                                    onClick={() => {
                                        OnRemoveDetail(index);
                                    }}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    {index < details.length - 1 && <Divider light className={classes.divider} />}
                </div>
            ))}
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/ClientDetails/ContactDetails.tsx